<template>
	<div class="col" gutter="20">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item v-for="(item, i) in breadcrumbs" :to="(!item.meta.noLink)?{ path: item.path, query: item.meta.query}: ''" :key="i">
				{{item.meta.breadcrumb}}
			</el-breadcrumb-item>
		</el-breadcrumb>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {
		breadcrumbs() {
			return this.$route.matched.filter(route => route.meta.breadcrumb);
		}
	}
};
</script>
